import script from "./AvailabilityCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AvailabilityCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./AvailabilityCalendar.vue?vue&type=style&index=0&id=4bff3faa&lang=scss"

const __exports__ = script;

export default __exports__